<template>
    <b-modal id="concern_delete" ref="concern_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.concern.data.attributes.name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('concern_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteConcern">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "ConcernDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'concern'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteConcern() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteConcern', this.concern)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-concern');

                            this.$notify('error filled', 'Success!', 'Deleted the concern!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('concern_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
